import React from 'react';

const Checkbox = ({ id, name, checked, onChange, className = '' }) => {
  return (
    <div className="inline-flex items-center">
      <label className={`relative flex items-center ${className}`}>
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          className="absolute w-0 h-0 opacity-0"
        />
        <div 
          className={`w-4 h-4 border rounded cursor-pointer transition-colors duration-200 ease-in-out flex items-center justify-center
            ${checked 
              ? 'bg-indigo-600 border-indigo-600' 
              : 'bg-white border-gray-300 hover:border-indigo-500'
            }`}
        >
          {checked && (
            <svg 
              className="w-3 h-3 text-white" 
              viewBox="0 0 16 16" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M13.3334 4L6.00008 11.3333L2.66675 8"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      </label>
    </div>
  );
};

export default React.memo(Checkbox);
